import { InsightsService } from '@app/app-initialisers/insights-service/insights.service';

export const InsightsServiceInit = (insightsService: InsightsService) => () => insightsService.insightsInit();
